module.exports = __webpack_public_path__ + "img/MET-France_80X30.d190cf92.png";